import {getServerTexts as getTexts, initTexts, texts, moreInfo} from '../../Localization/texts';

const entity = 'UI_MESSAGES';

const en = {
    exitForm: 'Exit the form?',
    dontSave: "Don't save",
    checkbox: 'Don’t ask me again',
    shouldSaveChangesTitle: 'Just before leaving,',
    shouldSaveChangesContent: 'Save your changes?',
    payAttention: 'Note,',
    shouldSearch: 'Search will not be activated, activate the search?',
    search: 'Yes, search',
    dontExit: 'Dont exit',
    deletItem: 'Do you want to delete the item?',
    yes: 'Yes',
    noChangedMyMind: "No, I've Changed My Mind",
    shouldSaveChanges2: 'Just before leaving, Stop without running the search?',
    yesExitSearch: 'Yes, exit the search',
    priorityHelp: 'Priority Help',
    accept: 'Accept',
    ctrlZContent: 'Delete all changes you just made?',
    ctrlZTitle: 'Ctrl + Z (Undo All)',
    cancel: 'Cancel',
    justMoment: 'Just a moment,',
    searchStopsShouldExit: 'Search',
    exitSearch: 'Search stopped, should leave anyway?',
    yesDeleteChanges: 'Yes, Delete',
    deleteData: 'The information cannot be restored after deletion',
    exitNoSave: 'Exit without save',
    contextMenuPopoverTitle: 'We’ve reorganized the context menu.',
    contextMenuPopoverText: 'Some of the setting items were moved to the gear icon menu.',
    dontDelete: 'Don’t Delete',
    wordPrintNoPluginTitle: 'Printing WORD templates require the Priority',
    moreInfo: 'More Info',
    close: 'Close',
    setAsDefualt: 'Do you want to save XXX as the default search?',
    no: 'No',
    confirmAndClose: 'OK, Close',
    backToProc: 'Back to program',
    deleteSearch: 'Delete this saved search?'
};

const he = {
    exitForm: 'לצאת מהמסך?',
    dontSave: 'לא לשמור',
    checkbox: 'לא לשאול אותי שוב',
    shouldSaveChangesTitle: 'רגע לפני היציאה,',
    shouldSaveChangesContent: 'האם לשמור את השינויים שבצעת?',
    payAttention: 'יש להשים לב,',
    shouldSearch: 'החיפוש לא יופעל, האם להפעיל את החיפוש?',
    search: 'כן, אני רוצה לחפש',
    dontExit: 'לא לצאת.',
    deletItem: 'האם ברצונך למחוק את הפריט?',
    yes: 'כן',
    shouldSaveChanges2: 'רגע, האם להפסיק בלי להפעיל את החיפוש?',
    yesExitSearch: 'כן, לצאת מהחיפוש',
    noChangedMyMind: 'לא, התחרטתי',
    priorityHelp: 'פריוריטי עזרה',
    accept: 'אישור',
    ctrlZContent: 'האם למחוק את כל השינויים שעשית עכשיו?',
    ctrlZTitle: 'Ctrl + Z (ביטול פעולות)',
    cancel: 'ביטול',
    justMoment: 'רק רגע,',
    searchStopsShouldExit: 'החיפוש הופסק, האם לצאת בכל זאת?',
    exitSearch: 'כן, לצאת בלי לחפש',
    yesDeleteChanges: 'כן למחוק',
    deleteData: 'לא ניתן לשחזר את המידע לאחר המחיקה',
    exitNoSave: 'לצאת בלי לשמור',
    contextMenuPopoverTitle: 'חידשנו את תפריט הקליק הימני',
    contextMenuPopoverText: 'חלק מהאפשרויות שבעבר היו שם נמצאות עכשיו בהגדרות המסך',
    dontDelete: 'לא למחוק',
    wordPrintNoPluginTitle: 'הדפסה בפורמט WORD מחייבת התקנה של Priority Client Plugin',
    moreInfo: 'מידע נוסף',
    close: 'סגירה',
    setAsDefualt: 'האם לקבוע את "XXX" כברירת מחדל?',
    no: 'לא',
    confirmAndClose: 'אישור וסגירה',
    backToProc: 'חזרה לתוכנית',
    deleteSearch: 'למחוק את החיפוש השמור?'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'exitNoSave',
    2: 'dontSave',
    3: 'checkbox',
    4: 'shouldSaveChangesTitle',
    5: 'shouldSaveChanges2',
    6: 'yesExitSearch',
    7: 'noChangedMyMind',
    8: 'deletItem',
    9: 'yes',
    10: 'payAttention',
    11: 'shouldSearch',
    12: 'search',
    13: 'dontExit',
    14: 'priorityHelp',
    15: 'accept',
    16: 'ctrlZContent',
    17: 'ctrlZTitle',
    18: 'cancel',
    19: 'shouldSaveChangesContent',
    20: 'justMoment',
    21: 'searchStopsShouldExit',
    22: 'exitSearch',
    23: 'yesDeleteChanges',
    24: 'deleteData',
    25: 'exitForm',
    28: 'contextMenuPopoverTitle',
    29: 'contextMenuPopoverText',
    30: 'dontDelete',
    31: 'wordPrintNoPluginTitle',
    33: 'moreInfo',
    34: 'close',
    35: 'setAsDefualt',
    36: 'no',
    37: 'confirmAndClose',
    38: 'backToProc',
    39: 'deleteSearch'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export const moreInfoText = moreInfo[entity];
export default texts[entity];
